const $ = require('jquery');
const Vue = require('vue');
const $window = $(window);
const pubsub = require('events/pubsub');
const analyticsUtilities = require('utilities/analyticsUtilities');
const model = require('model/model');

const fireEvent = analyticsUtilities.fireEvent;
const OUTBOUND_LINK = analyticsUtilities.events.OUTBOUND_LINK;

const tooltipId = 'tooltip-container';
const $tooltip = $(
	`<div id="${tooltipId}" class="tooltip" role="tooltip"><button class="focus-capture hidden-visually"></button><span class="tip"></span><span class="text"></span><button class="focus-capture hidden-visually"></button></div>`
);
const $tooltipText = $tooltip.find('.text');
const $tooltipFocusCapture = $tooltip.find('.focus-capture');
let boundA11yAttr = 'aria-describedby';
let keepTooltipOpen = false;
let pendingTimeout = null;
let containsAnchor = false;
let $tooltippedEl = null;
let handleRefocus = false;

$('body').append($tooltip);

function anchorClickHandler() {
	const path = this.getAttribute('href');
	const tag = this.getAttribute('data-outbound-link') || 'TOOLTIP';
	fireEvent(OUTBOUND_LINK, {
		tag,
		path
	});
}

/**
 * @param  {Boolean} force If true, immediately closes the tooltip without exception.
 *                         If false, waits a bit, and then closes the tooltip if the cursor is not
 *                         over the tooltip target or the tooltip bubble itself
 */
function hide(force) {
	if (pendingTimeout !== null) {
		clearTimeout(pendingTimeout);
	}

	const teardown = () => {
		pendingTimeout = null;

		if (keepTooltipOpen && !force) {
			return;
		}

		if (handleRefocus) {
			const $elToFocus = $tooltippedEl;
			Vue.nextTick(() => {
				$elToFocus.trigger('focus');
			});
		}

		$window.off('scroll.tooltip');
		$tooltip
			.css({
				top: '',
				left: ''
			})
			.removeClass('show')
			.removeClass('tooltip-bottom');

		if (containsAnchor) {
			$tooltip.attr('role', 'tooltip');
			$tooltip[0].querySelectorAll('.text a').forEach(anchor => {
				anchor.removeEventListener('click', anchorClickHandler);
			});
			containsAnchor = false;
		}

		if ($tooltippedEl) {
			$tooltippedEl.removeAttr(boundA11yAttr);
			$tooltippedEl = null;
		}
	};

	if (force) {
		teardown();
	} else {
		pendingTimeout = setTimeout(teardown, 250);
	}
}

pubsub.subscribe('hide-tooltips', function () {
	hide(true);
});

$tooltip
	.on('mouseover focusin', function () {
		keepTooltipOpen = true;
	})
	.on('mouseout', function () {
		keepTooltipOpen = false;

		hide();
	})
	.on('keydown', function (event) {
		const { key } = event;
		if (key === 'Escape') {
			event.preventDefault();
			handleRefocus = true;
			hide(true);
		}
	});

$tooltipFocusCapture.on('focus', function () {
	keepTooltipOpen = false;
	handleRefocus = true;

	hide(true);
});

const _showToolTip = el => {
	if (!el.dataset.tooltipText || $('html').hasClass('touching') || handleRefocus) {
		handleRefocus = false; //let user tab through, then reinstate tab key capture
		return;
	}

	if (pendingTimeout !== null) {
		clearTimeout(pendingTimeout);
	}

	pendingTimeout = null;

	$tooltippedEl = $(el);
	const offset = $tooltippedEl.offset();
	const arrowSize = 20;

	const textEl = $('<span>' + el.dataset.tooltipText + '</span>');
	const anchors = textEl.find('a');
	containsAnchor = anchors && anchors.length;

	if (containsAnchor) {
		anchors.each((idx, a) => {
			if (model.get('gcAddon')) {
				a.target = '_blank';
			}
			if (a.href.includes('http')) {
				a.addEventListener('click', anchorClickHandler);
			}
		});
		$tooltip.removeAttr('role');
	}

	if ($tooltippedEl.text().trim() || !!$tooltippedEl.attr('aria-label')) {
		boundA11yAttr = 'aria-describedby';
	} else {
		boundA11yAttr = 'aria-labelledby';
	}

	$tooltippedEl.attr(boundA11yAttr, tooltipId);

	if (el.dataset.tooltipShowEvent && analyticsUtilities.events[el.dataset.tooltipShowEvent] && !$tooltip.hasClass('show')) {
		fireEvent(el.dataset.tooltipShowEvent);
	}

	$tooltipText.html(textEl);

	// allow tooltip to render someplace invisible so we can get outer height
	// we were previously using tranform(translateY(-50%)) which is much more elegant
	// but caused blurry text in some cases, see WEBUI-1223
	$tooltip
		.css({
			top: -1000,
			left: 0
		})
		.addClass('show');

	const height = $tooltip.outerHeight();
	const width = $tooltip.outerWidth();
	let dimensions = null;
	let tooltipLocationClass = 'tooltip-right';

	if ($tooltippedEl.hasClass('tooltip-bottom')) {
		tooltipLocationClass = 'tooltip-bottom';
		dimensions = {
			top: offset.top + $tooltippedEl.outerHeight() - $window.scrollTop(),
			left: offset.left + $tooltippedEl.outerWidth() / 2 - width / 2
		};
	} else if ($tooltippedEl.hasClass('tooltip-top')) {
		tooltipLocationClass = 'tooltip-top';
		dimensions = {
			top: offset.top - height - arrowSize / 2 - $window.scrollTop(),
			left: offset.left + $tooltippedEl.outerWidth() / 2 - width / 2
		};
	} else {
		dimensions = {
			top: offset.top + $tooltippedEl.outerHeight() / 2 - $window.scrollTop() - height / 2,
			left: offset.left + $tooltippedEl.outerWidth()
		};
	}

	$tooltip.css(dimensions).addClass(tooltipLocationClass);

	$window.on('scroll.tooltip', function () {
		hide(false);
	});
};

const _bindToolTip = el => {
	$tooltippedEl = $(el);

	const focusTooltip = () => {
		Vue.nextTick(() => {
			$tooltip.find('a:first').trigger('focus');
		});
	};

	$tooltippedEl
		.on('mouseover.tooltip focus.tooltip', () => {
			_showToolTip(el);
		})
		.on('mouseout.tooltip blur.tooltip', function () {
			hide(!containsAnchor);
		})
		.on('keydown.tooltip', function (event) {
			const { key, shiftKey } = event;
			if (key === 'Escape') {
				hide(true);
			}
			if (key === 'Tab' && !shiftKey && containsAnchor) {
				event.preventDefault();
				focusTooltip();
			}
		})
		.on('click.tooltip', function () {
			if (containsAnchor) {
				focusTooltip();
			}
		});
};

module.exports = {
	bind(el, { value }) {
		el.dataset.tooltipText = value || '';
		const $el = $(el);

		if (!$el.hasClass('text-ellipsis')) {
			_bindToolTip(el);
		} else {
			// If the element we're attaching to has "text-ellipsis", then we assume
			// we only want a tooltip if the element content is overflowing and being
			// truncated
			$el.append('<span style="display:inline-block;" class="track-right-side"></span>');

			Vue.nextTick(function () {
				const elSpacingRight = parseFloat($el.children('*:not(.track-right-side)').last().css('margin-right') || 0);

				if ($el.width() < $el.children().width() || $el.find('.track-right-side').position().left - elSpacingRight > $el.width()) {
					_bindToolTip(el);
				}

				$el.find('.track-right-side').remove();
			});
		}
	},

	unbind(el) {
		$(el).off('mouseover.tooltip focus.tooltip').off('mouseout.tooltip blur.tooltip').off('keydown.tooltip').off('click.tooltip');
	},

	update(el, { value }) {
		el.dataset.tooltipText = value || '';
	}
};
